/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Error_Slot_TakenInputs */

const en_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That time was just booked. Please pick another.`)
};

const es_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese horario se acaba de reservar. Elige otro.`)
};

const de_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Uhrzeit wurde gerade gebucht. Bitte wählen Sie eine andere.`)
};

const zh_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该时间刚刚被预约，请选择其他时间。`)
};

const ar_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم حجز هذا الوقت للتو. يُرجى اختيار وقت آخر.`)
};

const fr_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce créneau vient d'être réservé. Veuillez en choisir un autre.`)
};

const vi_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khung giờ đó vừa được đặt. Vui lòng chọn giờ khác.`)
};

const sw_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muda huo umechukuliwa sasa hivi. Tafadhali chagua mwingine.`)
};

const th_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวลานี้เพิ่งถูกจองไป โปรดเลือกเวลาอื่น`)
};

const bs_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taj termin je upravo rezervisan. Odaberite drugi.`)
};

const ja_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その時間はたった今予約されました。別の時間を選択してください。`)
};

const ko_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`해당 시간은 방금 예약되었습니다. 다른 시간을 선택해 주세요.`)
};

const pt_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse horário acabou de ser reservado. Escolha outro.`)
};

const it_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo orario è appena stato prenotato. Scegline un altro.`)
};

const sv_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den tiden blev precis bokad. Välj en annan.`)
};

const nl_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dat tijdstip is net geboekt. Kies een ander tijdstip.`)
};

const da_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det tidspunkt er lige blevet booket. Vælg venligst et andet.`)
};

const nb_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det tidspunktet ble nettopp bestilt. Velg et annet.`)
};

const fi_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aika varattiin juuri. Valitse toinen aika.`)
};

const pl_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta godzina została właśnie zarezerwowana. Wybierz inną.`)
};

const ru_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это время только что забронировали. Выберите другое.`)
};

const tr_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu saat az önce ayırtıldı. Lütfen başka bir saat seçin.`)
};

const hi_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह समय अभी-अभी बुक हो गया। कृपया कोई दूसरा समय चुनें।`)
};

const id_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waktu tersebut baru saja dipesan. Silakan pilih waktu lain.`)
};

const ms_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masa itu baru sahaja ditempah. Sila pilih masa lain.`)
};

const cs_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento čas byl právě zarezervován. Vyberte prosím jiný.`)
};

const el_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αυτή η ώρα μόλις κρατήθηκε. Επιλέξτε άλλη.`)
};

const he_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`השעה הזו הוזמנה זה עתה. בחרו שעה אחרת.`)
};

const af_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daardie tyd is pas bespreek. Kies asseblief 'n ander een.`)
};

const hu_booking_error_slot_taken = /** @type {(inputs: Booking_Error_Slot_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ezt az időpontot épp most foglalták le. Kérjük, válassz másikat.`)
};

/**
* | output |
* | --- |
* | "That time was just booked. Please pick another." |
*
* @param {Booking_Error_Slot_TakenInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_error_slot_taken = /** @type {((inputs?: Booking_Error_Slot_TakenInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Error_Slot_TakenInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_error_slot_taken(inputs)
	if (locale === "de") return de_booking_error_slot_taken(inputs)
	if (locale === "zh") return zh_booking_error_slot_taken(inputs)
	if (locale === "ar") return ar_booking_error_slot_taken(inputs)
	if (locale === "fr") return fr_booking_error_slot_taken(inputs)
	if (locale === "vi") return vi_booking_error_slot_taken(inputs)
	if (locale === "sw") return sw_booking_error_slot_taken(inputs)
	if (locale === "th") return th_booking_error_slot_taken(inputs)
	if (locale === "bs") return bs_booking_error_slot_taken(inputs)
	if (locale === "ja") return ja_booking_error_slot_taken(inputs)
	if (locale === "ko") return ko_booking_error_slot_taken(inputs)
	if (locale === "pt") return pt_booking_error_slot_taken(inputs)
	if (locale === "it") return it_booking_error_slot_taken(inputs)
	if (locale === "sv") return sv_booking_error_slot_taken(inputs)
	if (locale === "nl") return nl_booking_error_slot_taken(inputs)
	if (locale === "da") return da_booking_error_slot_taken(inputs)
	if (locale === "nb") return nb_booking_error_slot_taken(inputs)
	if (locale === "fi") return fi_booking_error_slot_taken(inputs)
	if (locale === "pl") return pl_booking_error_slot_taken(inputs)
	if (locale === "ru") return ru_booking_error_slot_taken(inputs)
	if (locale === "tr") return tr_booking_error_slot_taken(inputs)
	if (locale === "hi") return hi_booking_error_slot_taken(inputs)
	if (locale === "id") return id_booking_error_slot_taken(inputs)
	if (locale === "ms") return ms_booking_error_slot_taken(inputs)
	if (locale === "cs") return cs_booking_error_slot_taken(inputs)
	if (locale === "el") return el_booking_error_slot_taken(inputs)
	if (locale === "he") return he_booking_error_slot_taken(inputs)
	if (locale === "af") return af_booking_error_slot_taken(inputs)
	if (locale === "hu") return hu_booking_error_slot_taken(inputs)
	return en_booking_error_slot_taken(inputs)
});